import { backgroundColors } from '@/assets';

export const NAVBAR_MENU_ITEM_LINK_DEFAULTS = {
  padding: '2px 4px 2px 4px',
  margin: '0px',
  overflow: 'hidden',
  borderRadius: '8px',
  background: 'none',
  color: '#000',
  fontSize: '16px',
  fontWeight: '500',
  fontFamily: 'Inter',
  letterSpacing: '0px',

  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
};

export const NAVBAR_MENU_ITEM_SEARCH_DEFAULTS = {
  padding: '8px',
  margin: '0px',
  overflow: 'hidden',
  borderRadius: '8px',
  background: 'none',
  color: '#a3a3a3',
  fontFamily: 'Inter',
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
  letterSpacing: '0px',
};

export const NAVBAR_MENU_ITEM_LOGO_DEFAULTS = {
  width: 'auto',
  height: '36px',
  padding: '0px',
  borderRadius: '8px',
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
  background: 'transparent',
};

export const NAVBAR_MENU_ITEM_BUTTON_DEFAULTS = {
  padding: '4px 8px 4px 8px',
  margin: '0px',
  overflow: 'hidden',
  borderRadius: '8px',
  background: backgroundColors.purple,
  color: '#fff',
  fontFamily: 'Inter',
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
  fontSize: '16px',
  letterSpacing: '0px',
  fontWeight: '500',
  iconColor: '#FFFFFF',
  iconPlacement: 'left',
  iconSize: '24px',
};
